import { Component, HostListener, OnInit } from '@angular/core';
import { EmployeeService } from '../employee-profile/employee-profile.service';
import { AddRolesService } from './add-roles.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { Location } from '@angular/common';
import { FormControl } from '@angular/forms';

interface listOfSubCompetency {
  id: string;
  employeeId: number;
  role: string;
  competencyId: number;
  subCompetencyIds: any[];
  isDeleted: boolean;
}

@Component({
  selector: 'app-add-roles',
  templateUrl: './add-roles.component.html',
  styleUrls: ['./add-roles.component.css']
})


export class AddRolesComponent implements OnInit {
  toppings = new FormControl('')
  storeIt = []

  filteredValues: any[] = [];
  currentEmployeeRoles: any[] = [];
  employeeId: number;
  addedRoles = [];
  originalRoles = [];
  removedRoles = [];
  finalAddedRoles = [];
  finalSaveCompetencyLeader: listOfSubCompetency[] = [];
  loading: boolean = false;
  competencyList = [];

  roles = [
    {
      title: "Application Roles",
    },
    {
      title: "Competency",
      repoName: "Competency"
    },
    // {
    //   title: "TimeSheet",
    //   repoName: "TimeSheet",
    //   checked: false,
    // },
 
  ]
  Competencies: any;
  subCompetencies: any;
  compChecked = false;
  subCompChecked = false;
  compId: number;
  compIdChecked = false;
  arryOfCompetencies: any = [];
  checkedCompetency: any;
  getComptencyLeaderDetails = [];
  isCheckedUser = true;
  isEmployeeSearched = true;
  selectedCompitencies: any = [0];
  selectedCompetency = [];
  compSubComp: boolean = false;
  comp: boolean = false;
  constructor(private employeeService: EmployeeService, private rolesService: AddRolesService, public toaster: ToastrService, private router: Router, private auth: AuthServiceService, private _location: Location,) { }

  ngOnInit() {
    this.getCurrentEmployeeRoles();
    this.listOfCompetencies();
  }

  getCurrentEmployeeRoles() {
    this.currentEmployeeRoles = Array(this.auth.getRole());
  }

  getFilteredValues(event) {
    this.competencyList = [];
    this.finalSaveCompetencyLeader = [];
    this.comp = false;
    this.compChecked = false;
    this.subCompChecked = false;
    this.employeeService.getEmployeesOnSearch(event).subscribe(res => {
      this.filteredValues = res.data ? res.data.profiles : []
    })
  }

  setSelectedEmployeeRoles(id) {
    if (id == localStorage.getItem('Id')) {
      this.isCheckedUser = true;
      this.isEmployeeSearched = true;
    }
    else {
      this.isCheckedUser = false;
      if (id != null) {
        this.isEmployeeSearched = false;
      }
    }
    this.employeeId = id;
    this.originalRoles = [];
    this.removedRoles = [];
    this.selectedCompitencies = [];
    this.selectedCompetency = [];
    this.finalAddedRoles = [];
    this.addedRoles = this.filteredValues.filter(x => x.employeeId == id)[0].roles ? this.filteredValues.filter(x => x.employeeId == id)[0].roles : [];
    this.addedRoles.forEach(role => {
      this.originalRoles.push(role)
    })
    if (this.addedRoles.includes('CompetencyLeader' || 'SubCompetencyLeader')) {
      this.rolesService.getCompetencyLeader(id).subscribe(competencyLeader => {
        this.getComptencyLeaderDetails = competencyLeader;
      })
      this.compSubComp = true;
      this.getSelectedCompetency(id);
      if (this.addedRoles.includes('CompetencyLeader') && !this.addedRoles.includes('SubCompetencyLeader')) {
        this.compChecked = true;
        this.comp = true;
      }
      else if (this.addedRoles.includes('SubCompetencyLeader') && !this.addedRoles.includes('CompetencyLeader')) {
        this.subCompChecked = true

      }
      else if (this.addedRoles.includes('CompetencyLeader' && 'SubCompetencyLeader')) {
        this.subCompChecked = true;
        this.compChecked = true;
        this.comp = true;
      }
    }
  }

  checkIsChecked(value) {
    if (this.addedRoles)
      return this.addedRoles.indexOf(value) >= 0;
  }

  checkHasAuthorization(value) {
    if (this.currentEmployeeRoles[0])
      return this.currentEmployeeRoles[0].indexOf(value) >= 0 || this.currentEmployeeRoles[0].indexOf('SuperAdmin') >= 0;
  }

  changeRole(event, value) {
    if (event.target.checked) {
      if (this.addedRoles.indexOf(value) < 0) {
        if (value == 'SuperAdmin') {
          this.addedRoles = [];
        }
        else {
          var rolelist = value.split('.')
          if (rolelist[1] == 'User') {
            if (this.addedRoles.indexOf(rolelist[0] + '.Admin') >= 0) {
              this.addedRoles.splice(this.addedRoles.indexOf(rolelist[0] + '.Admin'), 1)
            }
            if (rolelist[0] == 'Skill') {
              if (this.addedRoles.indexOf('Leadership') >= 0) {
                this.addedRoles.splice(this.addedRoles.indexOf('Leadership'), 1);
              }
            }

          }
          else if (rolelist == 'Leadership') {
            if (this.addedRoles.indexOf('Skill.User') >= 0) {
              this.addedRoles.splice(this.addedRoles.indexOf('Skill.User'), 1);
            }
          }
          else if (rolelist == 'CompetencyLeader' || rolelist == 'SubCompetencyLeader') {
            if (rolelist == 'CompetencyLeader') {
              this.comp = true;
              this.compChecked = true;
              this.compIdChecked = false;
            }

            else {
              this.subCompChecked = true;
              this.compChecked = false;
              this.compIdChecked = false;
            }
          }
          else {
            if (this.addedRoles.indexOf(rolelist[0] + '.User') >= 0) {
              this.addedRoles.splice(this.addedRoles.indexOf(rolelist[0] + '.User'), 1)
            }
          }
        }
        this.addedRoles.push(value);
      }
    }
    else {
      if (this.addedRoles.indexOf(value) >= 0) {
        this.addedRoles.splice(this.addedRoles.indexOf(value), 1)
      }
      if (value == 'CompetencyLeader') {
        this.comp = false;
        this.compChecked = false;
        this.finalSaveCompetencyLeader = this.finalSaveCompetencyLeader.filter(competencyLeader => {
          return competencyLeader.role !== 'CompetencyLeader';
        })

        for (let competency of this.competencyList) {
          if (!this.finalSaveCompetencyLeader.some(x => x.competencyId == competency.competencyId)) {
            this.competencyList = this.competencyList.filter(x => {
              this.selectedCompitencies[competency.competencyId - 1] = [];
              return x.competencyId !== competency.competencyId;
            })
          }
          this.isCheckedCompetency(competency.competencyId);
        }

      }
      if (value == 'SubCompetencyLeader') {
        this.subCompChecked = false;
        this.finalSaveCompetencyLeader = this.finalSaveCompetencyLeader.filter(x => {
          return x.role !== 'SubCompetencyLeader';

        })
        for (let competency of this.competencyList) {
          if (!this.finalSaveCompetencyLeader.some(x => x.competencyId == competency.competencyId)) {
            this.competencyList = this.competencyList.filter(x => {
              this.selectedCompitencies[competency.competencyId - 1] = []
              return x.competencyId !== competency.competencyId;

            })
          }
          this.checkIt(competency.competencyId);
        }
      }
    }
  }
  isSuperAdminSelected() {
    if (this.addedRoles)
      return this.addedRoles.indexOf('SuperAdmin') >= 0;
  }
  async updateRoles() {
    if (this.compChecked || this.subCompChecked) {
      if (this.compChecked) {
        if (this.competencyList.length <= 0) {
          return this.toaster.error("Select atleast one Competency")
        }
      }
      if (this.subCompChecked) {
        if (this.finalSaveCompetencyLeader.length <= 0) {
          return this.toaster.error("Select atleast one Subcompetency for selcted Competency")
        }
      }
      if (this.comp && this.subCompChecked) {
        for (let n of this.competencyList) {
          const a = this.finalSaveCompetencyLeader.some(x => x.competencyId == n.competencyId)
          if (!a) {
            return this.toaster.error("Select atleast one Subcompetency for selcted Competency")
          }

        }

      }

    }
    this.originalRoles.forEach(x => {
      if (this.addedRoles.indexOf(x) < 0) {
        this.removedRoles.push(x);
      }
    })
    this.addedRoles.forEach(x => {
      if (this.originalRoles.indexOf(x) < 0) {
        this.finalAddedRoles.push(x);
      }
    })

    if (this.employeeId) {
      this.loading = true;
      this.originalRoles = [];
      this.addedRoles.forEach(x => {
        this.originalRoles.push(x)
      })
      var employee = {
        "EmployeeId": this.employeeId,
        "AddedRoles": this.finalAddedRoles,
        "RemovedRoles": this.removedRoles
      }

      this.rolesService.updateRoles(employee).subscribe(x => {
        this.loading = false
        this.removedRoles = []
        this.finalAddedRoles = []
        this.toaster.success("Roles Updated Successfully")
      })
    }
    else {
      this.toaster.error("Please select employee")
    }
    if (this.compChecked || this.subCompChecked) {
      this.UpdateCompetencyLeader();
      setTimeout(() => {
        this.getSelectedCompetency(this.employeeId);
      }, 1500);
    }
  }

  backButton() {
    this.router.navigate(['/Home'])
  }

  navigateBack() {
    this._location.back();
  }

  listOfCompetencies() {
    this.rolesService.getCompetencies().subscribe(x => {
      this.Competencies = x.data;
      this.selectedCompitencies = new Array(this.Competencies.length)
    })
  }

  async changeOfCompetency(event, value, index) {

    for (let competency of this.selectedCompetency) {
      if (competency.competencyId == value) {
        this.selectedCompitencies[index] = competency.subCompetencyIds;
      }
    }
    if (event) {
      const sampleArray = {
        id: '',
        employeeId: this.employeeId,
        competencyId: value,
        checked: true
      }

      await this.rolesService.getSubCompetencies(value).subscribe(subCompetency => {
        sampleArray['subCompetencyIds'] = subCompetency.data;
        const subCompetencyList: listOfSubCompetency = {
          id: '',
          employeeId: this.employeeId,
          role: "CompetencyLeader",
          competencyId: value,
          subCompetencyIds: subCompetency.data.map(item => item.id),
          isDeleted: false
        }

        if (this.selectedCompitencies > 0) {
          let checkSelectedCompitencies = true;
          for (let i of subCompetencyList.subCompetencyIds) {
            checkSelectedCompitencies = this.selectedCompitencies[index].some(item => item == i)
            if (!checkSelectedCompitencies) {
              break;
            }
          }
          if (checkSelectedCompitencies) {
            this.selectedCompitencies[index].push(0);
          }

        }

        if (this.comp) {
          let a = false;
          for (let i of this.finalSaveCompetencyLeader) {
            if (i.competencyId == value) {
              a = true
              break;
            }
          }
          if (!a && !this.subCompChecked) {
            this.finalSaveCompetencyLeader.push(subCompetencyList);
          }
        }
      })
      if (this.comp || this.subCompChecked) {
        this.competencyList.push(sampleArray);
        this.checkIt(value);
      }
    }
    else {
      this.competencyList = this.competencyList.filter(object => {
        return object.competencyId !== value;
      })
      this.finalSaveCompetencyLeader = this.finalSaveCompetencyLeader.filter(object => {
        return object.competencyId !== value;
      })
      for (let i of this.selectedCompetency) {
        if (i.competencyId == value) {
          await this.rolesService.deleteCompetencyLeader(i.id).subscribe(x => {
            this.toaster.success("Deleted Unchecked Competency");
          })
        }
      }
    }
  }
  isCheckedCompetency(value) {
    if (this.compSubComp) {
      for (let i of this.finalSaveCompetencyLeader) {
        if (i.competencyId == value) {
          return true;
        }
      }
    }
    for (let i of this.competencyList) {
      if (i.competencyId == value) {
        return true
      }
      else {
        return false;
      }
    }

  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    $('#sidebar_r').removeClass('active');
    $('#sidebar').removeClass('active');
    $('.overlay').removeClass('active');
  }

  checkIt(value): boolean {
    if (this.compSubComp) {
      for (let i of this.selectedCompetency) {
        if (i.competencyId == value) {
          return true;
        }
      }
    }
    for (let i of this.competencyList) {
      if (i.competencyId == value && i.checked) {
        return true
      }
    }
  }
  getData(value) {
    if ((this.comp && this.subCompChecked) || (this.subCompChecked && !this.comp)) {
      for (let i of this.finalSaveCompetencyLeader) {
        if (i.competencyId == value) {
          this.selectedCompitencies[value - 1] = i.subCompetencyIds;
          if (i.role == 'CompetencyLeader') {
            this.selectedCompitencies[value - 1].push(0);
          }
        }
      }
    }
    for (let i of this.competencyList) {
      if (i.competencyId == value) {
        return i.subCompetencyIds
      }
    }
  }
  selectedSubCompetency = [];
  changeOfSubCompetencies(event, CompetencyId) {
    let checkZero = false
    if (event.value.length > 0) {
      checkZero = event.value.some(i => i == 0)
    }
    if (checkZero) {
      this.compChecked = true;
      let tempArray: any = []
      for (let i of this.competencyList) {
        if (i.competencyId == CompetencyId) {
          tempArray = i.subCompetencyIds.map(i => i.id);
        }
      }

      if (this.selectedCompetency.length > 0) {
        this.selectedCompitencies[CompetencyId - 1] = tempArray;
        this.selectedCompitencies[CompetencyId - 1].push(0);
        if (this.selectedCompetency.some(item => item.competencyId == CompetencyId)) {
          for (let i of this.finalSaveCompetencyLeader) {
            if (i.competencyId == CompetencyId) {
              i.role = 'CompetencyLeader';
              i.subCompetencyIds = tempArray;
            }
          }
        }

      }
      else {
        const tempObj: listOfSubCompetency = {
          id: '',
          employeeId: this.employeeId,
          role: "CompetencyLeader",
          competencyId: CompetencyId,
          subCompetencyIds: tempArray,
          isDeleted: false
        }
        this.finalSaveCompetencyLeader.push(tempObj);
      }
    }
    else {
      const sampleArray = {
        competencyId: CompetencyId,
        listSubcomp: event.value
      }
      this.selectedSubCompetency.push(sampleArray);
      const tempObj: listOfSubCompetency = {
        id: '',
        employeeId: this.employeeId,
        role: "SubCompetencyLeader",
        competencyId: CompetencyId,
        subCompetencyIds: event.value,
        isDeleted: false
      }
      if (this.finalSaveCompetencyLeader.length > 0) {
        const a = this.finalSaveCompetencyLeader.some(item => item.competencyId === CompetencyId);
        if (a) {
          for (let i of this.finalSaveCompetencyLeader) {
            if (i.competencyId == CompetencyId) {
              i.role = "SubCompetencyLeader";
              i.subCompetencyIds = event.value;
            }
          }
        }
        else {
          this.finalSaveCompetencyLeader.push(tempObj);
        }
      }
      else {
        this.finalSaveCompetencyLeader.push(tempObj)
      }
    }
  }

  async UpdateCompetencyLeader() {
    for (let i of this.finalSaveCompetencyLeader) {
      let m = i.subCompetencyIds.filter(e => e !== 0);
      i.subCompetencyIds = [];
      i.subCompetencyIds = m;
    }

    const finalList = [];
    for (let i of this.finalSaveCompetencyLeader) {
      if (i.id == null || i.id == "") {
        finalList.push(i);
      }
    }
    await this.rolesService.postCompetencyLeader(finalList).subscribe(x => {
      this.loading = false;
      this.toaster.success("Updated the role");
    },
      error => {
        this.toaster.error('Invalid')
      })
  }
  selectedSubCompetencies(value) {
    if (value = 1) {
      this.subCompetencies = [1, 2, 3];
      return [1, 2, 3]
    }
    else {
      this.subCompetencies = [];
      return []

    }
  }
  getSelectedCompetency(value) {
    this.rolesService.getCompetencyLeader(value).subscribe(x => {
      this.selectedCompetency = x.data;
      this.finalSaveCompetencyLeader = this.selectedCompetency;
      for (let i of this.selectedCompetency) {
        this.changeOfCompetency(true, i.competencyId, i.competencyId - 1)
      }
    });
  }
}
